export default __webpack_public_path__ + "static/media/Time.a8d6e0f8.svg";